export const API_URL = 'https://vskt-adminapi.vesomayman.vn';
